/** Fixed by the `key` in the extension's manifest, for Store and dev builds alike. */
export const EXTENSION_ID = "nkoaigamicaohhpkhpamjceofghohmdo";

/** Where users install the extension (P-2789). */
export const EXTENSION_STORE_URL =
  "https://chromewebstore.google.com/detail/punto/nkoaigamicaohhpkhpamjceofghohmdo";
